import Cookies from "js-cookie";
import { useCallback, useEffect, useState } from "react";
import { getDocument, getDocuments } from "./useDocument";
import { useFirestore } from "../firebase/FirestoreContext";
import { deleteDoc, updateDoc } from "firebase/firestore";
import getCartItemPriceData from "../functions/getCartItemPriceData";
import { cleanDataForDb } from "../utils/format";
import isProductAvailable from "../functions/isProductAvailable";

const cookieKey = 'fullProof_CartValidations'
export default function useCartValidations() {
  const firestore = useFirestore();
  const [validationErrors, setValidationErrors] = useState([]);

  useEffect(() => {
    const data = Cookies.get(cookieKey);
    if (data) {
      Cookies.remove(cookieKey);
      setValidationErrors(JSON.parse(data));
    }
  }, []);


  const setCartErrors = useCallback((errors) => {
    Cookies.set(cookieKey, JSON.stringify(errors));
    setValidationErrors(errors);
  }, [setValidationErrors]);

  const validateCart = useCallback(async (cartId) => {
    const cartItemsSnapshot = await getDocuments({
      firestore,
      path: `Carts/CartsList/DataBase/${cartId}/Items`
    })

    const errors = (await Promise.all(cartItemsSnapshot.docs.map(async (doc) => {
      const cartItem = doc.data();

      const listing = await getDocument({
        firestore,
        path: 'Listings/ListingsList/DataBase',
        id: doc.id,
      });

      const { product_name: name, final_price: cartPrice, quantity } = cartItem;

      if (!listing.data) {
        await deleteDoc(doc.ref);
        return {
          cartItem,
          message: `${name} is no longer available, it has been removed from your cart`,
          validation: 'listing_unavailable',
        }
      }

      const {
        listing_stock_amount,
      } = listing.data;

      if (!isProductAvailable(listing.data)) {
        await deleteDoc(doc.ref);
        return {
          cartItem,
          message: `${name} is now out of stock, it has been removed from your cart`,
          validation: 'out_of_stock',
        }
      }

      if (listing_stock_amount < quantity) {
        await updateDoc(doc.ref, { quantity: listing_stock_amount });
        return {
          cartItem,
          message: `The stock of "${name}" has gone down. We've adjusted the quantity in your cart.`,
          validation: 'stock_decrease',
        }
      }

      const priceData = await getCartItemPriceData(listing.data);

      if (priceData.final_price > cartPrice) {
        await updateDoc(doc.ref, cleanDataForDb(priceData));
        return {
          cartItem,
          message: `The price of "${name}" has increased.`,
          validation: 'price_increase',
        }
      }
    }))).filter((e) => e != null);

    setCartErrors(errors);

    return errors;
  }, [firestore, setCartErrors]);

  return { cartErrors: validationErrors, setCartErrors, validateCart }
}
